// @ts-nocheck
export const Fx = () => (
  <math xmlns="http://www.w3.org/1998/Math/MathML">
    <msub>
      <mi>f</mi>
      <mo>x</mo>
    </msub>
  </math>
);
